/* Publish by EComposer at 2026-09-28 12:39:54*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-5f6pk1ujxpv"]=  window.__ectimmers["ecom-5f6pk1ujxpv"] || {};
if(!this.$el||!window.EComModal)return;const t=this.isLive;let e=this.$el.querySelectorAll("[ecom-modal]");e.length&&t&&new window.EComModal(e,{gallery:!0,cssClass:["ecom-container-lightbox-"+this.id]})

                    });
                    
                        document.querySelectorAll('.ecom-5f6pk1ujxpv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5f6pk1ujxpv', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-lgpuz1qxssf"]=  window.__ectimmers["ecom-lgpuz1qxssf"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const n=t.querySelector(".ecom__element--button");if(!n)return;let o=parseInt(i.settings.animation_loop_time)*1e3||6e3,s=1e3;window.__ectimmers["ecom-lgpuz1qxssf"]["kkk085vcq"] = setInterval(function(){n.classList.add("animated"),setTimeout(function(){n.classList.remove("animated")},s)},o)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let n=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const o=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},n);try{Shopify.analytics.publish("ec_custom_events",o)}catch(a){console.error("[EC Tracking] Error publishing analytics event:",a)}const s=e.getAttribute("href"),r=e.getAttribute("target");s&&s!=="#"&&s!=="javascript:void(0)"&&(r==="_blank"?window.open(s,"_blank"):setTimeout(function(){window.location.href=s},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-lgpuz1qxssf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lgpuz1qxssf', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}